export default "__VITE_ASSET__PUG7kO3$__"